var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, firstImageProperty } from '@shapeable/utils';
import { breakpoints } from '@shapeable/theme';
import { EntityTypeImage } from './entity-type-image';
import { Image } from '../elements/image';
import { ResponsiveContainer } from '../elements/responsive-container';
var cls = classNames('entity-image');
// a bunch of path constants to change the priority of which image is used
export var EntityImagePathsDefault = ['banner.image', 'banner.image2x', 'banner.thumbnail', 'openGraph.image', 'image'];
export var EntityImagePathsThumbnail = ['banner.thumbnail', 'image', 'thumbnail', 'openGraph.image', 'banner.image', 'banner.image2x'];
export var EntityImageDefaultProps = {
  iconSize: 300,
  fill: true,
  paths: EntityImagePathsDefault,
  useFallback: false
};
// -------- Styles -------->
var FallbackStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ResponsiveContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Fallback: styled(EntityTypeImage)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), FallbackStyles),
  ResponsiveContainer: styled(ResponsiveContainer)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ResponsiveContainerStyles),
  Image: styled(Image)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
/**
 * A standard rendering component for `Entity` images.
 * This will attempt to render:
 *  1. A Banner first, if available
 *  2. The openGraph image
 *  3. A custom image (if provided as an Image structure)
 *  4. A generic icon fallback if none of these are available
 */
export var EntityImage = function (props) {
  var className = props.className,
    entity = props.entity,
    iconSize = props.iconSize,
    iconColor = props.iconColor,
    overlay = props.overlay,
    paths = props.paths,
    fill = props.fill,
    useFallback = props.useFallback;
  var image = firstImageProperty(entity, paths);
  var aspectRatio = props.aspectRatio || (image && image.width && image.height ? {
    base: image.width / image.height
  } : {
    base: 16 / 9,
    tablet: 16 / 9
  });
  if (!image && !useFallback) {
    return null;
  }
  if (!image && entity.__typename) {
    return React.createElement(My.Fallback, {
      className: className,
      iconSize: iconSize,
      iconColor: iconColor,
      aspectRatio: aspectRatio,
      entityTypeName: entity.__typename
    });
  }
  return React.createElement(My.ResponsiveContainer, {
    fill: fill,
    className: cls.name(className),
    aspectRatio: aspectRatio
  }, React.createElement(My.Image, {
    image: image
  }));
};
export var EntityThumbnailImage = function (props) {
  return React.createElement(EntityImage, __assign({
    paths: EntityImagePathsThumbnail
  }, props));
};
EntityImage.defaultProps = EntityImageDefaultProps;
EntityImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;